// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");

function decodeEvent(json) {
  return {
          source: Json_decode.field("source", Json_decode.string, json),
          timestamp: Json_decode.field("timestamp", Json_decode.string, json),
          desc: Json_decode.field("desc", Json_decode.string, json),
          email: Json_decode.field("email", Json_decode.string, json),
          phone: Json_decode.field("phone", Json_decode.string, json),
          details: Json_decode.field("details", Json_decode.string, json)
        };
}

function TimelineEvent(props) {
  var onSelect = props.onSelect;
  var $$event = props.event;
  var icons = Belt_MapString.fromArray([
        [
          "Shopify",
          Image$ReactHooksTemplate.shopify
        ],
        [
          "Freshdesk",
          Image$ReactHooksTemplate.freshdesk
        ],
        [
          "Freshchat",
          Image$ReactHooksTemplate.freshchat
        ],
        [
          "Pragma",
          Image$ReactHooksTemplate.pragma
        ]
      ]);
  var iconSrc = Belt_MapString.getWithDefault(icons, $$event.source, Image$ReactHooksTemplate.avatar);
  return JsxRuntime.jsxs("li", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            alt: $$event.source,
                            src: iconSrc
                          }),
                      className: "absolute -left-5 top-0 w-10 h-10 rounded-full bg-bleudefrance flex items-center justify-center text-white z-10 border-4 border-gray-50"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("time", {
                                    children: $$event.timestamp,
                                    className: "block text-sm text-gray-500 mb-2"
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: $$event.desc,
                                    className: "text-gray-800 font-semibold"
                                  })
                            ],
                            className: "p-4 rounded-lg shadow-sm transition cursor-pointer " + (
                              props.isSelected ? "bg-blue-50 border border-blue-200 shadow-md" : "bg-white hover:bg-gray-50 hover:shadow"
                            ),
                            onClick: (function (param) {
                                Curry._1(onSelect, $$event);
                              })
                          }),
                      className: "ml-8 w-full"
                    })
              ],
              className: "relative flex items-start"
            });
}

var make = TimelineEvent;

exports.decodeEvent = decodeEvent;
exports.make = make;
/* react/jsx-runtime Not a pure module */
